export function ConvertText(val, compareWith, replaceWith) {
  if (val === null || val === undefined) return val;
  return val.toString().toLowerCase() === compareWith.toString().toLowerCase() ? replaceWith : val;
}

export const DerbyshireOrgCode = "dhcft-01";